var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.descTemplate)?_c('div',{staticClass:"instype-result-wrap"},[_c('liability',{attrs:{"temp":_vm.descTemplate,"data":_vm.descData,"product-name-list":_vm.productNameList,"show-type":1,"kind":_vm.kind},on:{"disShow":_vm.fetchDisData}},[_c('a',{staticClass:"disease-btn",attrs:{"slot":"disease-btn"},slot:"disease-btn"},[_vm._v("病种")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }